/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancel_AnywayInputs */

const en_cancel_anyway = /** @type {(inputs: Cancel_AnywayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel anyway`)
};

const de_cancel_anyway = /** @type {(inputs: Cancel_AnywayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trotzdem kuendigen`)
};

const fr_cancel_anyway = /** @type {(inputs: Cancel_AnywayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler quand meme`)
};

const es_cancel_anyway = /** @type {(inputs: Cancel_AnywayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar de todos modos`)
};

const it_cancel_anyway = /** @type {(inputs: Cancel_AnywayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulla comunque`)
};

const nl_cancel_anyway = /** @type {(inputs: Cancel_AnywayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toch annuleren`)
};

const pl_cancel_anyway = /** @type {(inputs: Cancel_AnywayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anuluj mimo wszystko`)
};

const fi_cancel_anyway = /** @type {(inputs: Cancel_AnywayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peruuta silti`)
};

const da_cancel_anyway = /** @type {(inputs: Cancel_AnywayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuller alligevel`)
};

const sv_cancel_anyway = /** @type {(inputs: Cancel_AnywayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avbryt ändå`)
};

/**
* | output |
* | --- |
* | "Cancel anyway" |
*
* @param {Cancel_AnywayInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cancel_anyway = /** @type {((inputs?: Cancel_AnywayInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_AnywayInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cancel_anyway(inputs)
	if (locale === "fr") return fr_cancel_anyway(inputs)
	if (locale === "es") return es_cancel_anyway(inputs)
	if (locale === "it") return it_cancel_anyway(inputs)
	if (locale === "nl") return nl_cancel_anyway(inputs)
	if (locale === "pl") return pl_cancel_anyway(inputs)
	if (locale === "fi") return fi_cancel_anyway(inputs)
	if (locale === "da") return da_cancel_anyway(inputs)
	if (locale === "sv") return sv_cancel_anyway(inputs)
	return en_cancel_anyway(inputs)
});